var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mb-6" },
    [
      _vm.isNotificationsExist
        ? _c(
            "div",
            {
              staticClass:
                "flex justify-end pb-5 pt-2 border-b border-primary-color",
            },
            [
              _c("MarkAllAsRead", {
                staticClass: "mr-2",
                attrs: {
                  disabled: _vm.isMarkAllAsReadDisabled,
                  currentUserId: _vm.currentUser.id,
                  processing: _vm.processingMarkAsRead,
                },
                on: {
                  "update:processing": function ($event) {
                    _vm.processingMarkAsRead = $event
                  },
                  completed: _vm.markAllAsRead,
                },
              }),
              _c("DeleteReadNotifications", {
                attrs: {
                  disabled: _vm.isDeleteReadDisabled,
                  currentUserId: _vm.currentUser.id,
                  processing: _vm.processingDeleteRead,
                },
                on: {
                  "update:processing": function ($event) {
                    _vm.processingDeleteRead = $event
                  },
                  completed: _vm.removeAllNotifications,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "pt-5 flex items-center flex-col" },
        [
          _vm.isNotificationsExist
            ? _c(
                "LoadingOverlay",
                {
                  staticClass: "w-full h-full md:w-10/12 lg:w-9/12 xl:w-7/12",
                  attrs: {
                    hasData: _vm.isNotificationsExist,
                    loading: _vm.processing,
                  },
                },
                _vm._l(
                  _vm.notificationsData.notifications,
                  function (notification) {
                    return _c("NotificationItem", {
                      key: notification.id,
                      staticClass: "notifications__splitter mb-3 bg-white",
                      attrs: {
                        message: notification.message,
                        link: notification.link,
                        notificationId: notification.id,
                        read: notification.read,
                        createdAt: notification.created_at,
                      },
                      on: {
                        notificationDeleted: _vm.removeNotification,
                        notificationRead: _vm.markNotificationAsRead,
                      },
                    })
                  }
                ),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.infiniteScrollShown
        ? _c("InfiniteLoading", {
            attrs: { identifier: _vm.infiniteId },
            on: { infinite: _vm.loadMore },
            scopedSlots: _vm._u(
              [
                {
                  key: "spinner",
                  fn: function () {
                    return [
                      _c("Spinner", {
                        staticClass: "w-full flex justify-center",
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "no-more",
                  fn: function () {
                    return [
                      _vm.isNotificationsListEmpty
                        ? _c("EmptyListPlaceholder", {
                            attrs: { title: "Notifications list is empty" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "image",
                                  fn: function () {
                                    return [_c("EmptyListImageInbox")]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1693747661
                            ),
                          })
                        : _c("span", [_vm._v(" No more notifications ")]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3604591245
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }